import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { PaginatedWorkshops } from '../api/types';
import config from '../config';

async function getChainWorkshops(id: number, axios: AxiosInstance): Promise<PaginatedWorkshops> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/chain/${id}/workshop`, {});
  return data;
}

export default function useChainWorkshopsQuery(id: number) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(id),
    queryFn: () => getChainWorkshops(id, axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(id: number) {
  return ['ChainWorkshops', id] as const satisfies QueryKey;
}

useChainWorkshopsQuery.getKey = getKey;
